import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { SyncBadge } from '@/components/SyncBadge';
import { ThemeToggle } from '@/components/ThemeToggle';
import { ToastContainer } from '@/components/Toast';

export default function Layout() {
  const navigate = useNavigate();
  const { nome, matricula, kind, clear } = useAuthStore();

  const handleLogout = async () => {
    await clear();
    navigate('/login', { replace: true });
  };

  const showFuncionarioNav = kind === 'FUNCIONARIO';
  const initial = (nome?.[0] ?? 'U').toUpperCase();

  return (
    <div className="d-flex flex-column min-vh-100 bg-body">
      {/* Header sticky topo */}
      <div
        className="bg-body border-bottom shadow-sm sticky-top"
        style={{ paddingTop: 'env(safe-area-inset-top)' }}
      >
        <div className="container-xxl px-3 px-md-4 py-3 d-flex align-items-center gap-3">
          <div className="symbol symbol-40px symbol-circle flex-shrink-0">
            <span className="symbol-label fs-4 fw-bold bg-light-primary text-primary">
              {initial}
            </span>
          </div>
          <div className="flex-grow-1 min-w-0">
            <div className="fw-bold fs-6 text-gray-900 text-truncate">
              {nome ?? 'Visitante'}
            </div>
            {matricula ? (
              <div className="text-muted fs-8">Matrícula {matricula}</div>
            ) : (
              <div className="text-muted fs-8">
                {kind === 'FUNCIONARIO' ? 'Funcionário' : 'Administrador'}
              </div>
            )}
          </div>
          {showFuncionarioNav && <SyncBadge />}
          <ThemeToggle compact />
          <button
            type="button"
            onClick={handleLogout}
            className="btn btn-icon btn-sm btn-active-light-danger"
            title="Sair"
            aria-label="Sair"
          >
            <i className="bi bi-box-arrow-right fs-4" />
          </button>
        </div>
      </div>

      {/* Main */}
      <main
        className={`flex-grow-1 container-xxl px-3 px-md-4 py-4 ${
          showFuncionarioNav ? 'pb-7' : ''
        }`}
      >
        <Outlet />
      </main>

      <ToastContainer />

      {/* Bottom nav fixa (só funcionário) */}
      {showFuncionarioNav && (
        <nav
          className="bg-body border-top shadow-sm fixed-bottom"
          style={{
            paddingBottom: 'calc(env(safe-area-inset-bottom) + 0.25rem)',
            zIndex: 1030,
          }}
          aria-label="Navegação"
        >
          <div className="container-xxl px-2">
            <div className="d-flex justify-content-around py-2">
              <BottomLink to="/bater-ponto" icon="bi-clock-history" label="Ponto" />
              <BottomLink to="/historico" icon="bi-list-check" label="Histórico" />
              <BottomLink to="/biometria" icon="bi-person-badge" label="Biometria" />
            </div>
          </div>
        </nav>
      )}
    </div>
  );
}

function BottomLink({
  to,
  icon,
  label,
}: {
  to: string;
  icon: string;
  label: string;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex-fill text-center text-decoration-none py-1 ${
          isActive ? 'text-primary' : 'text-muted'
        }`
      }
      style={{ minHeight: 56 }}
    >
      {({ isActive }) => (
        <>
          <i
            className={`bi ${icon} fs-2 d-block`}
            style={{ lineHeight: 1.1 }}
            aria-hidden="true"
          />
          <small className={`fw-semibold ${isActive ? 'text-primary' : ''}`}>
            {label}
          </small>
        </>
      )}
    </NavLink>
  );
}
